import FinancialData from '../../../../components/common/FinancialData';

interface RowProps {
  label: string;
  value: number;
  type: 'percentage' | 'money' | 'time' | 'text';
  bold?: boolean;
  boxBg?: string;
}
const TableRow = ({
  label,
  value,
  type,
  bold = false,
  boxBg = 'bg-white',
}: RowProps) => {
  const getFormat = (valueToFormat: number, type: string) => {
    if (type === 'money') {
      return <FinancialData text={valueToFormat} />;
    } else if (type === 'percentage') {
      return `${valueToFormat.toFixed(1)}%`;
    } else if ('text') {
      return valueToFormat;
    } else {
      return `${valueToFormat} mths`;
    }
  };

  return (
    <section
      className={`flex w-full justify-between pr-5 pl-5 items-center gap-2 ${
        bold ? ' font-bold' : ''
      }`}
    >
      <label>{label}</label>
      <label className={`flex justify-end ${boxBg} pr-3 w-40 rounded border`}>
        {getFormat(value, type)}
      </label>
    </section>
  );
};

export default TableRow;
